import { useCallback } from 'react';
export const useSetHeaderViewModeJudgeRef = (arg) => {
    const { judgeRef } = arg;
    return useCallback((current) => {
        if (current && judgeRef) {
            judgeRef.current = current;
        }
    }, [judgeRef]);
};
